import { __ } from '@wordpress/i18n'

export default { notFound: __('No Magazines', 'dhsv_theme') }
